


























import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice } from '@/types/model'
import RadioIcon from '@/components/RadioIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'

export default Vue.extend({
  components: {
    PreviewScreen,
    RadioIcon,
    AliveIndicator,
  },
  model: {
    prop: 'chosen',
    event: 'chose'
  },
  props: {
    /** Currently chosen in this radio group. Use v-model to access this. */
    chosen: {
      type: Object
    } as PropValidator<IDevice|null>,
    device: {
      type: Object
    } as PropValidator<IDevice>,
    mappedDisplayIndex: {
      type: Number,
      default: -1
    },
    /** For hint user this area is draggable */
    draggerBlinking: {
      type: Boolean
    }
  },
  data (): {
    dragging: boolean
  } {
    return {
      dragging: false
    }
  },
  computed: {
    thisDeviceIsChosen (): boolean { return this.device === this.chosen },

  },
  methods: {
    blinkLed () { easyapi.blinkLed(this, this.device) },
    openDeviceRenameDialog () {
      this.$router.push({ name: 'vwlst_details_rxmap_rename', params: {mac: this.device.mac} })
    },
    chooseThisDevice () { this.$emit('chose', this.device) }, // See the doc of v-model (v-model is a syntax sugar)
    dragStart (evt: DragEvent) {
      this.dragging = true
      evt.dataTransfer.setData('text/unusedThough', 'For Firefox, this is required.')
      this.$emit('dragStart', this.device)
    },
    drag (evt: DragEvent) { //
    },
    dragEnd (evt: DragEvent) {
      this.dragging = false
      this.$emit('dragEnd', this.device)
    },
    mouseEnter (evt: MouseEvent) {
      this.$emit('mouseEnter', this.device)
    },
    mouseLeave (evt: MouseEvent) {
      this.$emit('mouseLeave', this.device)
    },
  }
})
